﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import VeilederUtvekslingDto from '../Models/VeilederUtvekslingDto';
import { valgReducer } from './Valg/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { satserReducer, universiteterReducer } from './Satser/Reducers';

const rootReducer = combineReducers<VeilederUtvekslingAppState>({
    valg: valgReducer,
    epiContext: (
        state: EpiContext<VeilederUtvekslingDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederUtvekslingDto>,
    ): EpiContext<VeilederUtvekslingDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
    resultat: resultatReducer,
    satser: satserReducer, 
    universiteter: universiteterReducer,
});

export type VeilederUtvekslingAppState = EpiAppStateMedSteg<VeilederUtvekslingDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: ReturnType<typeof satserReducer>; 
    universiteter: ReturnType<typeof universiteterReducer>;
};

export default function configureStore(): Store<VeilederUtvekslingAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}